export const formatNumber0 = (number: number) => {
    return number ? Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: true
    }).format(number) : '-';
}

export const formatNumber1 = (number: number) => {
    return number ? Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
        useGrouping: true
    }).format(number) : '-';
}

export const formatNumber2 = (number: number) => {
    return number ? Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true
    }).format(number) : '-';
}
